(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('avgByHourReportController', avgByHourReportController);

  /** @ngInject */
  function avgByHourReportController ($scope, $translate, reportExportUtil, exportToCsv, AvgByHourReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new AvgByHourReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('HOURS'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.NUMBER,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('AVG_MONEY_BY_HOUR_REPORT'),
          true);
    }

  }
})();
